<template>
    <!--Edit-->
    <div class="container">
        <div class="page-inner">
            <div class="page-header gp-admin-page-heading">
                <h3 class="fw-bold">Acordo de sinistro</h3>
                <ul class="breadcrumbs"><li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li><li class="separator"><i class="fa fa-chevron-right"></i></li><li class="nav-item"><a href="#" @click.prevent="$router.push('/listasinistrosacordo')">Acordos de sinistros</a></li><li class="separator"><i class="fa fa-chevron-right"></i></li><li class="nav-item">Detalhe</li></ul>
            </div>
            <div class="row">
                <div class="col-md-12" v-if="Sinistro!=''">
                    <div class="card gp-agreement-card">
                        <div class="card-body">
                            <v-tabs v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                <v-tab value="dados" class="tabinfo"
                                    style="font-size: 13px;text-transform: none !important;"><v-icon size="16">mdi-handshake-outline</v-icon> Acordo do sinistro</v-tab>
                            </v-tabs>
                            <v-window v-model="tab">
                                <v-window-item value="dados">
                                    <v-form>
                                        <v-container>
                                            <v-card class="gp-agreement-cancel-bar" color="#f7f7f7">
                                                <div class="gp-cancel-bar-heading"><v-icon size="17">mdi-cancel</v-icon><strong>Cancelamento do acordo</strong><span>Status: {{ SinistroAcordo.statusAcordo }}</span></div>
                                                <div v-if="podeCancelarAcordo" class="gp-cancel-bar-form">
                                                    <div class="form-group"><label>Observação do cancelamento</label><textarea v-model="observacaoCancelamento" class="form-control" rows="2" maxlength="500" placeholder="Informe o motivo do cancelamento"></textarea></div>
                                                    <button type="button" class="btn btn-danger gp-cancel-agreement-button" :disabled="cancelandoAcordo" @click.prevent="CancelarAcordo()"><v-icon size="15">mdi-cancel</v-icon>{{ cancelandoAcordo ? 'Cancelando...' : 'Cancelar acordo' }}</button>
                                                </div>
                                                <div v-else-if="acordoCancelado" class="gp-cancel-bar-note"><strong>Observação:</strong><span>{{ observacaoCancelamentoRegistrada || 'Nenhuma observação foi informada.' }}</span></div>
                                                <div v-else class="gp-agreement-locked-message">Este acordo não permite cancelamento.</div>
                                            </v-card>
                                            <div class="row gp-agreement-overview-row">
                                                <v-col cols="12" md="7" class="gp-agreement-left-column">
                                                    <v-card style="padding: 15px;margin-top: 5px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                Dados Cliente
                                                            </h5>
                                                             <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Garantidora:</strong> {{ this.SinistroAcordo.garNome
                                                                }} - <strong>Imobiliária:</strong> {{ this.SinistroAcordo.imoNome
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Cliente:</strong> {{ this.SinistroAcordo.pedDescricao
                                                                }} <v-icon @click="dialogCliente = true;">mdi-folder-open</v-icon>
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Data Inicial:</strong> {{
                                                                formattedDate(this.SinistroAcordo.snaDtInclusao) }}  -  <strong>Contratação:</strong>  {{ SinistroAcordo.pedId
                                                                }}
                                                            </p>                                                    
                                                        </div>
                                                    </v-card>
                                                      <v-card v-if="PedidosEndereco != ''" style="padding: 15px;margin-top: 5px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">Endereço
                                                                Contratação
                                                            </h5>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Endereço:</strong> {{
                                                                    PedidosEndereco[0].pdcEndereco
                                                                }}, {{ PedidosEndereco[0].pdcNumero }} - {{
                                                                    PedidosEndereco[0].pdcComplemento }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Cidade/UF:</strong> {{
                                                                    PedidosEndereco[0].pdcCidade }} /
                                                                {{ PedidosEndereco[0].pdcEstado }} -   <strong>Bairro:</strong> {{
                                                                    PedidosEndereco[0].pdcBairro
                                                                }} -  <strong>CEP:</strong> {{
                                                                    PedidosEndereco[0].pdcCep }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Tipo Imóvel:</strong> {{
                                                                    PedidosEndereco[0].pdcTipo
                                                                }} {{ PedidosEndereco[0].pdcResidencialTipo
                                                                }}
                                                            </p>
                                                        </div>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="12" md="5" class="gp-agreement-right-column">
                                                      <v-card v-if="SinistroAcordoSinistro != ''" class="gp-linked-claims-card" color="#f7f7f7">
                                                        <h5 class="subtitulo"><v-icon size="17">mdi-shield-alert-outline</v-icon> Sinistros vinculados <span class="gp-linked-count">{{ SinistroAcordoSinistro.length }}</span></h5>
                                                        <div class="gp-linked-claims-scroll">
                                                        <v-table style="background-color: transparent;">
                                                                <thead>
                                                                    <tr>
                                                                        <th class="text-left">
                                                                            Id
                                                                        </th>
                                                                        <th class="text-left">
                                                                            Sinistros
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item, index) in SinistroAcordoSinistro"
                                                                        :key="index">
                                                                        <td>{{ item.sntId }}</td>
                                                                        <td>{{ item.sntCodigo }}</td>
                                                                    </tr>
                                                                </tbody>
                                                        </v-table>
                                                        </div>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="12" md="12">
                                                     <v-card style="padding: 15px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                 Informações Parcelamento
                                                            </h5>
                                                        </div>
                                                         <v-row style="padding-top: 5px;padding-bottom: 5px;" v-if="SinistroTitulos.length > 0" >
                                                              <v-table style="background-color: transparent;">
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Acordo
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Parcela
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Valor
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Vencimento
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Juros %
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Mora %
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Forma Pgto
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Status
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Visualização
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Ações
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(item, index) in SinistroTitulos"
                                                                            :key="index">
                                                                            <td>{{ item.snaId }}</td>
                                                                            <td>{{ item.sttDescricao }}</td>
                                                                            <td>{{ formatarValor(item.sttValorPrincipal) }}</td>
                                                                            <td>{{ formattedDate(item.sttDtVencimento) }}</td>
                                                                            <td>{{ formatarDecimal(item.sttPercJuroDiario) }}</td>
                                                                            <td>{{ formatarDecimal(item.sttValorMora) }}</td>
                                                                            <td>{{ item.mpgNome }}</td>
                                                                            <td>{{ item.stlNome }}</td>
                                                                             <td style="text-align: center;">
                                                                                <v-btn icon v-if="item.stbNomeInterno != '' && item.stbNomeInterno != null && item.stlId == 10"
                                                                                    @click.prevent="VisualizarDocumento(item.stbNomeInterno)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-eye</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Visualizar Documento</v-tooltip>
                                                                                </v-btn>
                                                                                 <v-btn icon v-if="item.stlId == 20 && item.stdNomeInterno != '' && item.stdNomeInterno != null"
                                                                                    @click.prevent="VisualizarDocumento(item.stdNomeInterno)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-eye</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Visualizar Comprovante</v-tooltip>
                                                                                </v-btn>
                                                                            </td>
                                                                              <td style="text-align: center;">
                                                                                <v-btn icon v-if="!acordoCancelado && ((item.stbNomeInterno == '' || item.stbNomeInterno == null) && item.stlId == 10)"
                                                                                    @click.prevent="OpenModalDoc(item)"
                                                                                    variant="text">
                                                                                    <v-icon style="color:blue">mdi-file-upload</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Adicionar Boleto</v-tooltip>
                                                                                </v-btn>
                                                                                <v-btn icon v-if="!acordoCancelado && item.stbNomeInterno != '' && item.stbNomeInterno != null && item.stlId == 10"
                                                                                    @click.prevent="RemoverDocumento(item.stbId)"
                                                                                    variant="text">
                                                                                    <v-icon style="color:red">mdi-file-remove</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Excluir Boleto</v-tooltip>
                                                                                </v-btn>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                            </v-table>
                                                         </v-row>
                                                    </v-card>
                                                </v-col>
                                            </div>
                                        </v-container>
                                    </v-form>
                                </v-window-item>
                            </v-window>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

     <!--modal Cliente-->
        <v-row justify="center">
            <v-dialog v-model="dialogCliente" class="controlcelEnd gp-agreement-dialog" transition="dialog-bottom-transition" max-width="980">
                <v-card class="gp-dialog-card">
                    <v-card-title class="gp-dialog-title"><span><v-icon size="19">mdi-account-details-outline</v-icon> Informações do cliente</span><button type="button" class="gp-dialog-close" @click.prevent="dialogCliente = false"><v-icon size="18">mdi-close</v-icon></button>
                    </v-card-title>
                    <v-card-text class="gp-dialog-content">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col v-if="Cliente != ''" cols="12" md="6"
                                        style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeEmpresa }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF/CNPJ: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliDocumento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">Razão Social: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliRazaoSocial }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">Responsável: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliResponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliCampoExtra1 }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefone }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsapp }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmail }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimento) }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEstadoCivil }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col v-if="Endereco != ''" cols="12" md="6">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                <span style="font-weight: 500;">Endereço Alternativo: </span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleEndereco }} - {{ Endereco.cleNumero }} - {{
                                                    Endereco.cleComplemento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Cidade/UF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleCidade }} / {{ Endereco.cleEstado }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Bairro: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleBairro }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CEP: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleCep }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col
                                        v-if="Cliente != '' && Cliente != null && Cliente.cliCpfConjuge && Cliente.cliCpfConjuge != '' && Cliente.cliCpfConjuge != null"
                                        cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Conjuge: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliCpfConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefoneConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsappConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmailConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimentoConjuge) }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span v-html="Cliente.cliTexto1"></span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col
                                        v-if="Cliente != '' && Cliente != null && Cliente.cliCpfCorresponsavel && Cliente.cliCpfCorresponsavel != '' && Cliente.cliCpfCorresponsavel != null"
                                        cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Corresponsável: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliCpfCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefoneCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsappCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmailCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimentoCorresponsavel)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEstadoCivilCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome Pai: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomePaiCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome Mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeMaeCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span v-html="Cliente.cliTexto2"></span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="gp-dialog-actions">
                        <v-spacer></v-spacer>
                        <button type="button" class="gp-dialog-secondary" @click.prevent="dialogCliente = false">Fechar</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

         <!--modal documento-->
        <v-row justify="center">
            <v-dialog v-model="dialogDocumento" persistent class="controlcelEnd gp-agreement-dialog" transition="dialog-bottom-transition" max-width="620">
                <v-card class="gp-dialog-card">
                    <v-card-title class="gp-dialog-title"><span><v-icon size="19">mdi-file-upload-outline</v-icon> Documento de pagamento</span><button type="button" class="gp-dialog-close" @click.prevent="dialogDocumento = false"><v-icon size="18">mdi-close</v-icon></button>
                    </v-card-title>
                    <v-card-text class="gp-dialog-content">
                        <v-form>
                            <v-container>
                                <v-row>
                                     <v-col cols="12" md="12" style="text-align: center;">
                                            <label style="font-size: 25px !important;font-weight: 600;">{{DescricaoParcela}}</label>
                                    </v-col>
                                     <v-col cols="12" md="12">
                                        <div class="form-group">
                                            <label>Numero do código Barras</label>
                                            <input v-model="SinitroTituloBoleto.stbCodigoBarra" type="text" maxlength="100"
                                                class="form-control" />
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="12">
                                        <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                            PDF</label>
                                        <v-file-input v-model="selectedFileDebito"
                                            label="Selecione o arquivo" variant="underlined"
                                            prepend-icon="mdi-file"
                                            accept="image/*,application/pdf"></v-file-input>
                                    </v-col>
                                    <v-col cols="12" md="12" style="text-align: center;">
                                        <button type="button" class="btn btn-success"
                                            @click.prevent="AdicionarDocumento()"
                                            style="color:#ffffff;margin-top: 20px;">
                                            Salvar
                                        </button>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions class="gp-dialog-actions">
                        <v-spacer></v-spacer>
                        <button type="button" class="gp-dialog-secondary" @click.prevent="dialogDocumento = false">Fechar</button>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'
import { useRoute } from 'vue-router';

export default {
    name: 'SinistroAcordoDetalheView',
    components: {
        EasyDataTable,
        moment
    },
    setup() {
        const route = useRoute();
        const id = route.params.id;
        return {
            id,
        };
    },
    data: () => ({
        tab: null,
        User: {
            garid: 0,
            tpeid: 0,
            pesid: 0,
            cusid: 0
        },
        searchValue: '',
        MostraGrid: true,
        headers: [],
        SinistroAcordo:{},
        SinistroTitulos:[],
        //pedidoendereco
        PedidosEndereco: [],
        Cliente: {},
        Endereco: [],
        dialogCliente: false,
        dialogDocumento: false,
        SinitroTituloBoleto: {
            stbId: 0,
            sttId: 0,
            stbDtInclusao: null,
            stbNomeOriginal: '',
            stbNomeInterno: '',
            stbCodigoBarra: ''
        },
        DescricaoParcela: '',
        selectedFileDebito: '',
        SinistroAcordoSinistro: [],
        cancelandoAcordo: false,
        observacaoCancelamento: '',
    }),
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
                return {
                    ...item,
                    proOrdem: parseInt(item.proOrdem),
                };
            });
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(v) {
            const n = Number(v) || 0;
            return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        formatarDecimal(valor) {
            // Verifica se o valor é inteiro
            if (Number.isInteger(valor)) {
                return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            // Formata normalmente para valores com casas decimais
            return parseFloat(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/SinistroAcordoDetalhe/upload`, formData);
            return uploadResult;
        },
        buildFileUrl(path) {
            if (!path) return '';
            const rel = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/SinistroAcordoDetalhe/GetFileByParam?param=${encodeURIComponent(rel)}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
        VisualizarDocumento(item) {
            if (item) {
                this.openInNewTab(item);
            }
        },
        //enderecoPedido
        async SelecionarEnderecoPedido() {
            this.PedidosEndereco = [];
            await axios.get('/Telas/SinistroAcordoDetalhe/GetAllByPedIdEndereco/' + this.SinistroAcordo.pedId)
                .then(response => {
                    this.PedidosEndereco = response.data;
                    // console.log('PedidosEndereco')
                    // console.log(this.PedidosEndereco)
                })
                .catch(error => {
                    console.error(error);
                });


        },
        //Boleto
        OpenModalDoc(value){
          this.dialogDocumento=true;
          this.SinitroTituloBoleto.sttId = value.sttId;
          this.DescricaoParcela = value.sttDescricao;
        },
        async AdicionarDocumento(){
            if (!this.selectedFileDebito) {
                return this.$mensagemAviso("Selecione Documento");
            }
            if (this.SinitroTituloBoleto.stbCodigoBarra == '' || this.SinitroTituloBoleto.stbCodigoBarra == null ) {
                const result = await this.$mensagemConfirma('Confirma salvar sem codigo de barras?');
                if (!result?.isConfirmed) return;
            }

              try {
                    const uploadSuccess = await this.UploadImg(this.selectedFileDebito[0]);

                    if (uploadSuccess && uploadSuccess.data && uploadSuccess.data.nameFile) {
                        this.SinitroTituloBoleto.stbNomeOriginal = this.selectedFileDebito[0].name;
                        this.SinitroTituloBoleto.stbNomeInterno = uploadSuccess.data.nameFile;
                        this.SinitroTituloBoleto.stbDtInclusao = moment().format('YYYY-MM-DDTHH:mm:ss');
                        await axios.post('/Telas/SinistroAcordoDetalhe/AddSinistroAcordoBoleto', this.SinitroTituloBoleto);
                        this.dialogDocumento = false;
                        this.Get();
                    } else {
                        this.$mensagemErro("Erro inesperado ao processar o arquivo. Tente novamente.");
                    }
                } catch (error) {
                    // Trata erro retornado pelo backend (ex: BadRequest)
                    const mensagem = error.response?.data || "Erro ao enviar o documento.";
                    this.$mensagemErro(mensagem);
                }

        },
        async RemoverDocumento(value){
           const result = await this.$mensagemConfirma('Confirma exclusão desse boleto?');
           if (!result?.isConfirmed) return;
               await axios.delete('/Telas/SinistroAcordoDetalhe/DeleteSinistroAcordoBoleto/' +  value);
               this.Get();

        },
        async CancelarAcordo(){
            if (this.cancelandoAcordo) return;
            const observacao = String(this.observacaoCancelamento || '').trim();
            if (!observacao) {
                return this.$mensagemAviso('Informe a observacao do cancelamento.');
            }
            const result = await this.$mensagemConfirma('Confirma cancelar este acordo e enviar o saldo pendente para cobranca?');
            if (!result?.isConfirmed) return;

            try {
                this.cancelandoAcordo = true;
                await axios.put('/Telas/SinistroAcordoDetalhe/CancelarAcordo/' + this.SinistroAcordo.snaId, { observacao });
                this.$mensagemSucesso('Acordo cancelado com sucesso.');
                this.observacaoCancelamento = '';
                this.Get();
            } catch (error) {
                console.error(error);
                this.$mensagemErro('Nao foi possivel cancelar o acordo.');
            } finally {
                this.cancelandoAcordo = false;
            }
        },
        async Get() {
            var _id = '';
            if (this.id != '') {
                _id = this.id;
            }
          await axios.get(`/Telas/SinistroAcordoDetalhe/GetDados/` + _id)
            .then(response => {
                const d = response?.data ?? {};              
                const first = a => (Array.isArray(a) && a.length) ? a[0] : null;
                const asArr = v => Array.isArray(v) ? v : [];
                const toNum = v => (v == null || v === '') ? 0 : Number(String(v).replace(/\./g, '').replace(',', '.')) || 0;
                const sumBy = (list, selector) => asArr(list).reduce((acc, item) => acc + (selector(item) || 0), 0);

                // ───────── Atribuições seguras ─────────
                this.User.tpeid = d.tpeId ?? null;
                this.User.garid = d.garId ?? null;
                this.User.cusid = d.cusId ?? null;
                this.User.pesid = d.pesId ?? null;
                this.SinistroAcordo = d.sinistroAcordo ?? {};
                this.SinistroTitulos = asArr(d.sinistroTitulos);
                this.SinistroAcordoSinistro = asArr(d.sinistroAcordoSinistros);
                this.Cliente = d.cliente;
                this.Endereco = first(d.clienteEndereco) ?? {};
                // Chama só no final (se depender dos dados acima)
                if (this.SinistroAcordo != ''){
                 this.SelecionarEnderecoPedido?.();
                }

                //console.log('this.SinistroAcordo')
                //console.log(this.SinistroAcordo)
                console.log('this.SinistroTitulos')
                console.log(this.SinistroTitulos)
               //    console.log('this.ListaSinistroDocumentoHistorico')
               // console.log(this.ListaSinistroDocumentoHistorico)

            })
            .catch(err => {
                console.error('Erro ao buscar dados do sinistro:', err);
                // Defaults seguros em caso de erro
                this.SinistroAcordo = {};
            });

        }
    },
    created() {
        this.Get();
    },
    computed: {
        podeCancelarAcordo() {
            const status = String(this.SinistroAcordo?.statusAcordo || '').toUpperCase();
            return !!this.SinistroAcordo?.snaId && status !== 'CANCELADO' && status !== 'CUMPRIDO';
        },
        acordoCancelado() {
            const status = String(this.SinistroAcordo?.statusAcordo || '').toUpperCase();
            return status === 'CANCELADO';
        },
        observacaoCancelamentoRegistrada() {
            return this.SinistroAcordo?.snaObservacaoCancelamento
                || this.SinistroAcordo?.snaObsCancelamento
                || this.SinistroAcordo?.snaObservacao
                || this.SinistroAcordo?.observacaoCancelamento
                || '';
        }
    },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}

.fontaprova {
    font-size: 16px;
    font-weight: 600;
}
.gp-agreement-card{overflow:hidden;border:1px solid #e1d9cd;border-radius:14px}.gp-agreement-card>.card-body{padding:0}.gp-agreement-card :deep(.gp-client-tabs){padding:8px 14px 0;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-agreement-card :deep(.v-tab){gap:6px}.gp-agreement-card :deep(.v-window-item>.v-form>.v-container){max-width:none;padding:16px}.gp-agreement-card :deep(.v-card){padding:15px!important;border:1px solid #e1d9cd!important;border-radius:12px!important;background:#fff!important;color:#4d586d!important;box-shadow:none!important}.gp-agreement-card :deep(.v-col>.v-card+.v-card){margin-top:12px!important}.gp-agreement-card :deep(.subtitulo){display:flex;align-items:center;min-height:38px;margin:-15px -15px 14px!important;padding:11px 15px!important;border-bottom:1px solid #e8e1d7;background:#fcfaf7;color:#102a5a;font-size:13px!important;font-weight:800}.gp-agreement-card :deep(.texto-mensagem){margin-bottom:7px!important;color:#4d586d!important;font-size:11.5px!important;line-height:1.45}.gp-agreement-card :deep(.v-table){overflow:hidden;margin:10px 0;border:1px solid #e8e1d7;border-radius:10px;font-size:10.5px}.gp-agreement-card :deep(.v-table th){background:#f1ede7;color:#42506a;font-size:9px;text-transform:uppercase}.gp-agreement-card :deep(.form-control){border-radius:9px;font-size:12px}.gp-agreement-card :deep(.btn){min-height:34px;padding:7px 13px;border:0;border-radius:9px;font-size:11px;font-weight:700}
.gp-agreement-dialog :deep(.v-overlay__content){width:calc(100% - 28px)}.gp-dialog-card{overflow:hidden;border:1px solid #e1d9cd!important;border-radius:14px!important;background:#fff!important;box-shadow:0 18px 50px rgba(16,42,90,.18)!important}.gp-dialog-title{display:flex;align-items:center;justify-content:space-between;min-height:56px;padding:13px 18px!important;border-bottom:1px solid #e8e1d7;background:#fcfaf7!important;color:#102a5a}.gp-dialog-title>span{display:flex;align-items:center;gap:8px;font-size:14px;font-weight:800}.gp-dialog-title :deep(.v-icon){color:#d96f00}.gp-dialog-close{display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border:1px solid #ddd6cc;border-radius:9px;background:#fff;color:#677386}.gp-dialog-content{max-height:70vh;overflow-y:auto;padding:16px 18px!important;color:#4d586d}.gp-dialog-content :deep(.v-container){max-width:none;padding:0}.gp-dialog-content :deep(.v-row){margin:-6px}.gp-dialog-content :deep(.v-col){padding:6px;font-size:11.5px}.gp-dialog-content :deep(label){display:block;margin-bottom:5px;color:#3d485c;font-size:10.5px;font-weight:700}.gp-dialog-content :deep(.form-control),.gp-dialog-content :deep(.v-field){min-height:35px;border-radius:9px;font-size:11.5px}.gp-dialog-actions{min-height:58px;padding:11px 18px!important;border-top:1px solid #e8e1d7;background:#fcfaf7}.gp-dialog-secondary{min-width:92px;min-height:34px;padding:7px 14px;border:1px solid #9ba4b0;border-radius:9px;background:#fff;color:#4f5b6d;font-size:11px;font-weight:700}
.gp-agreement-card :deep(.subtitulo .v-icon){margin-right:7px;color:#d96f00}.gp-cancel-agreement-button{display:inline-flex;align-items:center;justify-content:center;gap:6px;width:100%;margin-top:12px;background:#dc3545!important;color:#fff!important}.gp-agreement-locked-message{margin-top:12px;padding:9px 11px;border:1px solid #e8e1d7;border-radius:9px;background:#f8f6f2;color:#778195;font-size:10.5px}
.gp-linked-count{display:inline-flex;align-items:center;justify-content:center;min-width:24px;height:20px;margin-left:auto;padding:0 7px;border-radius:10px;background:#e9f0ff;color:#102a5a;font-size:10px;font-weight:800}.gp-linked-claims-scroll{max-height:250px;overflow:auto;padding-right:2px}.gp-linked-claims-scroll :deep(.v-table){margin-top:0}.gp-cancellation-note{margin-top:12px;padding:11px 12px;border:1px solid #f0c9c9;border-left:4px solid #dc3545;border-radius:9px;background:#fff5f5;color:#6f3d43;font-size:11px}.gp-cancellation-note strong{display:block;margin-bottom:5px;color:#a32936;font-size:10.5px}.gp-cancellation-note p{margin:0;white-space:pre-wrap;line-height:1.45}
.gp-agreement-card :deep(.gp-agreement-cancel-bar){margin-bottom:10px;padding:10px 13px!important;border-left:4px solid #dc3545!important}.gp-cancel-bar-heading{display:flex;align-items:center;gap:7px;color:#102a5a;font-size:11px}.gp-cancel-bar-heading>.v-icon{color:#dc3545}.gp-cancel-bar-heading strong{font-size:12px}.gp-cancel-bar-heading span{margin-left:auto;padding:4px 8px;border-radius:999px;background:#f4eee6;color:#5f6878;font-size:9.5px;font-weight:700}.gp-cancel-bar-note{display:flex;gap:5px;margin-top:8px;padding-top:8px;border-top:1px solid #eee2d9;color:#6f3d43;font-size:10.5px}.gp-cancel-bar-note strong{color:#a32936}.gp-cancel-bar-form{display:grid;grid-template-columns:minmax(0,1fr) 150px;align-items:end;gap:10px;margin-top:8px}.gp-cancel-bar-form .form-group{margin:0}.gp-cancel-bar-form textarea{min-height:48px}.gp-cancel-bar-form .gp-cancel-agreement-button{margin:0;height:36px}.gp-agreement-overview-row{align-items:stretch}.gp-agreement-left-column,.gp-agreement-right-column{display:flex;flex-direction:column}.gp-agreement-right-column :deep(.gp-linked-claims-card){display:flex;flex:1;min-height:0;flex-direction:column;margin-top:5px!important}.gp-linked-claims-card .gp-linked-claims-scroll{flex:1;max-height:none;min-height:0;overflow:auto}.gp-linked-claims-card :deep(.v-table){height:100%}
@media(max-width:767.98px){.gp-agreement-card :deep(.v-window-item>.v-form>.v-container){padding:10px}.gp-dialog-content{max-height:72vh;padding:12px!important}.gp-dialog-content :deep(.v-col[style*="border-right"]){border-right:0!important}.gp-dialog-secondary{width:100%}.gp-cancel-bar-heading{align-items:flex-start;flex-wrap:wrap}.gp-cancel-bar-heading span{margin-left:0}.gp-cancel-bar-form{grid-template-columns:1fr}.gp-cancel-bar-note{flex-direction:column}.gp-linked-claims-card .gp-linked-claims-scroll{max-height:260px}}
</style>
